<template>
  <div id="navigation">
      <div></div>

      <div class="wrapper" @click="clicked(0)">
        <router-link to="/homeDesktop">
          <div v-if="getNavbarActive[0]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <img src="./../../public/icons/logoText.svg" height="50px"/>
          <div v-if="getNavbarActive[0]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </router-link>
      </div>

    <div class="wrapper" @click="clicked(1)">
      <router-link to="/configuratorDesktop">
        <div class="wrapper">
          <div v-if="getNavbarActive[1]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <div class="text">
            <img v-if="language == 'DE'" src="./../../public/icons/konfigurator.svg" height="18px" />
            <img v-if="language == 'EN'" src="./../../public/icons/configuratorEnglish.svg" height="35px" />
          </div>
          <div v-if="getNavbarActive[1]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </div>
      </router-link>
    </div>

    <div class="wrapper" @click="clicked(2)">
      <router-link to="/bees">
        <div style="width: 100%; height: 100%;">
          <div v-if="getNavbarActive[2]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <div class="text">
            <img v-if="language == 'DE'" src="./../../public/icons/bees.svg" height="30px" style="position: relative; top: -8px;"/>
            <img v-if="language == 'EN'" src="./../../public/icons/beesEnglish.svg" height="35px" />
          </div>
          <div v-if="getNavbarActive[2]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </div>
      </router-link>
    </div>

    <!-- <div class="wrapper" @click="clicked(3)">
      <router-link to="/sustainabilityDesktop">
        <div style="width: 100%; height: 100%;">
          <div v-if="getNavbarActive[3]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <div class="text">
            <img v-if="language == 'DE'" src="./../../public/icons/nachhaltigkeit.svg" height="18px" />
            <img v-if="language == 'EN'" src="./../../public/icons/sustainabilityEnglish.svg" height="35px" />
          </div>
          <div v-if="getNavbarActive[3]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </div>
      </router-link>
    </div> -->

    <div class="wrapper" @click="clicked(4)">
      <router-link to="/about">
        <div style="width: 100%; height: 100%;">
          <div v-if="getNavbarActive[4]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <div class="text">
            <img v-if="language == 'DE'" src="./../../public/icons/ueberUns.svg" height="18px" />
            <img v-if="language == 'EN'" src="./../../public/icons/aboutEnglish.svg" height="35px" />
          </div>
          <div v-if="getNavbarActive[4]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </div>
      </router-link>
    </div>

    <div class="wrapper" @click="clicked(5)">
      <router-link to="/faq">
        <div style="width: 100%; height: 100%;">
          <div v-if="getNavbarActive[5]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
          <div class="text">
            <img v-if="language == 'DE'" src="./../../public/icons/fragen.svg" height="18px" />
            <img v-if="language == 'EN'" src="./../../public/icons/faqEnglish.svg" height="35px" />
          </div>
          <div v-if="getNavbarActive[5]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
        </div>
      </router-link>
    </div>

    <div class="wrapper" @click="clicked(6)">
      <router-link to="/cartDesktop">
        <div v-if="getNavbarActive[6]" class="frameLeft"><img src="./../../public/icons/frameLeft.svg" height="50px"/></div>
        <!-- <img src="./../../public/icons/cart.svg" height="50px"/> -->
        <img src="./../../public/icons/cart.svg" height="45px"/>
        <div v-if="getNavbarActive[6]" class="frameRight"><img src="./../../public/icons/frameRight.svg" height="50px"/></div>
      </router-link>
    </div>

  </div>
</template>

<script>

export default {
  name: 'navigation',
  components: {
    // HelloWorld
  },
  data() {
    return{
      language: ""
    }
   },
   mounted (){
     if (this.getLanguage == "EN"){
       this.language = "EN"
     } else {
       this.language = "DE"
     }
   },
   computed: {
     getNavbarActive(){
       return this.$store.getters.getNavbarActive;
     },
     getLanguage(){
       return this.$store.getters.getLanguage;
     }
   },
   methods: {
     clicked(index){
       this.$store.dispatch("setNavbarActive", index);
     }
   }
}
</script>

<style scoped>
  .v-application a {
    /* color: #F2CFC4; */
    /* display: none; */
  }
  .frameLeft{
    position: absolute;
    height: 50px;
    /* background-image: url("./../../public/icons/frame.svg");
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover; */
  }
  .frameRight{
    position: absolute;
    bottom: 0;
    right: 0;
    height: 50px;
    /* background-image: url("./../../public/icons/frame.svg");
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover; */
  }
  .text{
    height: 100%;
    width: 100%;
    position: absolute;
    top: 20%;
    margin: auto;
  }
  #navigation{
    background-color: var(--accentColor);
    padding-top: 10px;
    height: 100%;
    width: 100%;
    display: grid;
    grid-column-gap: 30px;
    grid-template-columns: 1fr 65px 150px 80px 115px 100px 65px 1fr
  }
  .wrapper{
    width: 100%;
    height: 50px;
    position: relative;
  }

</style>
